var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v("Copyrighted to DGV AUCTION PARTNERSHIP COMPANY")])])
}]

export { render, staticRenderFns }